export default{loyaltyPoint:"LogoCircleAgodacashFillIcon"};
